import $ from 'jquery';
import { Utility } from 'App/track/analytics/util';
import { Universal } from 'App/track/analytics/universal';
import { publish, unpublish, subscribe } from 'Util/pubsub';

var $link;
var downloadFiles = new RegExp(/\.(zip|pdf|doc?x|xls?x|ppt?x|txt)$/gi);

var selectors = {
	anchor: 'a'
};

var External = {
	init: function () {
		// console.log( 'Track External Init' );

		External = this;

		External._initElements();
		External._initEvents();
	},

	_initElements: function () {
		$link = $(selectors.anchor);
	},

	_initEvents: function () {
		$link.on('click', External._processLinkClick);
	},

	_processLinkClick: function () {
		var href = this.href;
		var trackIt = false;
		var category = 'External';
		var action;
		var label;

		if (External._isDownloadLink(href)) {
			var type = External._getDownloadFileType(href);
			trackIt = true;
			action = 'File';
			label = type + ' Link:' + this.getAttribute('href'); // Only record what the attribute contains. this.href adds the hostname to relative paths
		}

		if (External._isExternalLink(href)) {
			trackIt = true;
			action = 'Site';
			label = 'Link:' + href;
		}

		if (External._isMailtoLink(href)) {
			trackIt = true;
			action = 'Email';
			label = 'Email:' + External._getEmailAddress(href);
		}

		if (External._isTelephoneLink(href)) {
			trackIt = true;
			action = 'Telephone';
			label = 'Telephone:' + External._getEmailAddress(href);
		}

		if (trackIt) {
			var data = {};
			data.eventCategory = category;
			data.eventAction = action;
			data.eventLabel = label;

			Utility.publishEvent(data);
		}
	},

	_getDownloadFileType: function (url) {
		var extension = url.slice(url.search(downloadFiles));
		extension = extension.split('.')[1];
		extension = extension.split('?')[0];
		extension = extension.toUpperCase();

		return extension;
	},

	_getEmailAddress: function (url) {
		return url.split('mailto:')[1];
	},

	_isExternalLink: function (url) {
		var link = document.createElement('a');
		link.href = url;
		return link.hostname !== window.location.hostname;
	},

	_isMailtoLink: function (url) {
		return url.search('mailto') === 0;
	},

	_isTelephoneLink: function (url) {
		return url.search('tel') === 0;
	},

	_isDownloadLink: function (url) {
		return url.search(downloadFiles) !== -1;
	}
};

export { External };